export var getPageNavigation = function getPageNavigation() {
  var itemCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var displayedRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var result = {
    displayedRange: [],
    nextPageNumber: 1,
    previousPageNumber: 1,
    currentPageNumber: pageNumber,
    firstPageArrowEnabled: false,
    lastPageArrowEnabled: false,
    nextPageArrowEnabled: false,
    previousPageArrowEnabled: false
  };

  if (!itemCount || itemCount < pageSize) {
    result.displayedRange = [1];
    return result;
  }

  var pageCount = Math.ceil(itemCount / pageSize);
  var displayedRange = [pageNumber - displayedRadius, pageNumber + displayedRadius];

  if (displayedRange[0] < 1) {
    displayedRange[1] += 1 - displayedRange[0];
    displayedRange[0] = 1;

    if (displayedRange[1] > pageCount) {
      displayedRange[1] = pageCount;
    }
  }

  if (displayedRange[1] > pageCount) {
    displayedRange[0] -= displayedRange[1] - pageCount;
    displayedRange[1] = pageCount;

    if (displayedRange[0] < 1) {
      displayedRange[0] = 1;
    }
  }

  for (var i = displayedRange[0]; i <= displayedRange[1]; i += 1) {
    result.displayedRange.push(i);
  }

  result.previousPageNumber = pageNumber - 1;
  result.nextPageNumber = pageNumber + 1;
  result.firstPageArrowEnabled = pageNumber > 1;
  result.lastPageArrowEnabled = pageNumber < pageCount;
  result.previousPageArrowEnabled = pageNumber > 1;
  result.nextPageArrowEnabled = pageNumber < pageCount;
  return result;
};